import type { ActorRole } from '../../types/prioritization/roles';

/**
 * Role-based styling tokens
 * Used for consistent visual identity across the application
 */

export const roleColors = {
  'list-owner': {
    text: 'text-green-600',
    bg: 'bg-green-50',
    border: 'border-green-500',
    hover: 'hover:bg-green-100',
    badge: 'bg-green-100 text-green-800 border-green-300'
  },
  'steward': {
    text: 'text-blue-600',
    bg: 'bg-blue-50',
    border: 'border-blue-500',
    hover: 'hover:bg-blue-100',
    badge: 'bg-blue-100 text-blue-800 border-blue-300'
  },
  'criteria-authority': {
    text: 'text-purple-600',
    bg: 'bg-purple-50',
    border: 'border-purple-500',
    hover: 'hover:bg-purple-100',
    badge: 'bg-purple-100 text-purple-800 border-purple-300'
  },
  'facilitator': {
    text: 'text-orange-600',
    bg: 'bg-orange-50',
    border: 'border-orange-500',
    hover: 'hover:bg-orange-100',
    badge: 'bg-orange-100 text-orange-800 border-orange-300'
  },
  'cross-map-lead': {
    text: 'text-red-600',
    bg: 'bg-red-50',
    border: 'border-red-500',
    hover: 'hover:bg-red-100',
    badge: 'bg-red-100 text-red-800 border-red-300'
  },
  'strategist': {
    text: 'text-gray-600',
    bg: 'bg-gray-50',
    border: 'border-gray-500',
    hover: 'hover:bg-gray-100',
    badge: 'bg-gray-100 text-gray-800 border-gray-300'
  }
};

// Get role-based classes
export function getRoleClasses(role: ActorRole) {
  return roleColors[role];
}

// Lifecycle state colors (structural state is only 'item'; priority is contextual)
export const lifecycleStateColors: Record<string, { text: string; bg: string; border: string; badge: string }> = {
  item: {
    text: 'text-yellow-600',
    bg: 'bg-yellow-50',
    border: 'border-yellow-300',
    badge: 'bg-yellow-100 text-yellow-800'
  },
  default: {
    text: 'text-gray-600',
    bg: 'bg-gray-50',
    border: 'border-gray-300',
    badge: 'bg-gray-100 text-gray-800'
  }
};

// Safe getter for lifecycle state colors
export function getLifecycleStateColors(state: string | undefined | null) {
  return lifecycleStateColors[state || 'default'] || lifecycleStateColors.default;
}

// Above/below the line colors
export const cutLineColors = {
  above: {
    text: 'text-green-700',
    bg: 'bg-green-50',
    border: 'border-green-400',
    badge: 'bg-green-100 text-green-800'
  },
  below: {
    text: 'text-gray-600',
    bg: 'bg-gray-50',
    border: 'border-gray-300',
    badge: 'bg-gray-100 text-gray-700'
  }
};

// Drift severity colors
export const driftSeverityColors = {
  low: {
    text: 'text-yellow-600',
    bg: 'bg-yellow-50',
    border: 'border-yellow-300'
  },
  medium: {
    text: 'text-orange-600',
    bg: 'bg-orange-50',
    border: 'border-orange-300'
  },
  high: {
    text: 'text-red-600',
    bg: 'bg-red-50',
    border: 'border-red-300'
  }
};

